import { createContext } from 'react';

const CreateProgramContext = createContext({});

export default CreateProgramContext;
